export default "__VITE_ASSET__0gT0Nwr___"